// Import Packages
import React from 'react';

// import Helpers
import { numberToLetters } from '../../../../../../../helpers/helper';

function ColumnSelection({ v, type, dataTableValue, setDataTableValue, size, captureDown, captureOver }) {

    return (
        v.slice(0, size === 'medium' ? 4 : 30).map((row, i) => {
            if (size === 'medium') {
                row = row.slice(0, 2);
            }
            if (i === 0) {
                return (
                    <tr>
                        {
                            row.map((col, index) =>
                                type === 'string-single-column' ?
                                    <th onClick={() => setDataTableValue(index)}>
                                        {
                                            index === 0 &&
                                            <span className='tr-row-number'>
                                                {i + 1}
                                            </span>
                                        }
                                        <span className='column-letter-name'>
                                            {numberToLetters(index)}
                                        </span>
                                        {col}
                                    </th>
                                    :
                                    type === 'string-columns' ?
                                        <th onMouseOverCapture={(e) => captureOver(index)} onMouseDownCapture={(e) => captureDown(e, index)}
                                        >
                                            {
                                                index === 0 &&
                                                <span className='tr-row-number'>
                                                    {i + 1}
                                                </span>
                                            }
                                            <span className='column-letter-name'>
                                                {numberToLetters(index)}
                                            </span>
                                            {col}
                                        </th>
                                        : <th onClick={() => setDataTableValue(index)}
                                            className={`${dataTableValue === index ? 'active-col-for-header' : ''}`}>
                                            {
                                                index === 0 &&
                                                <span className='tr-row-number'>
                                                    {i + 1}
                                                </span>
                                            }
                                            <span className='column-letter-name'>
                                                {numberToLetters(index)}
                                            </span>
                                            {col}
                                        </th>
                            )
                        }
                    </tr>
                )
            }
            return (
                <tr>
                    {
                        row.map((col, index) =>
                            type === 'string-single-column' ?
                                <td onClick={() => setDataTableValue(index)}
                                    className={`${dataTableValue === index ? 'active-col' : ''}`} style={{ cursor: 'default' }}>
                                    {
                                        index === 0 &&
                                        <span className='tr-row-number'>
                                            {i + 1}
                                        </span>
                                    }
                                    {col}
                                </td>
                                :
                                type === 'string-columns' ?
                                    <td
                                        onMouseOverCapture={(e) => captureOver(index)} onMouseDownCapture={(e) => captureDown(e, index)}

                                        className={`${dataTableValue && dataTableValue.find(x => x === index) !== undefined ? 'active-col' : ''}`}
                                        style={{ cursor: 'default' }}
                                    >
                                        {
                                            index === 0 &&
                                            <span className='tr-row-number'>
                                                {i + 1}
                                            </span>
                                        }
                                        {col}
                                    </td>
                                    : <td>
                                        {
                                            index === 0 &&
                                            <span className='tr-row-number'>
                                                {i + 1}
                                            </span>
                                        }
                                        {col}
                                    </td>
                        )
                    }
                </tr>
            )
        })
    )

}

export default ColumnSelection;